import * as Yup from 'yup'
// Schemas are built at module load; the non-React `t` works because i18n
// initializes on import.
import { t } from 'i18n'

const zipValidation = Yup.string()
  .matches(/^[0-9]+$/, t('validation:onlyDigits'))
  .min(5, t('validation:exactlyFiveDigits'))
  .max(5, t('validation:exactlyFiveDigits'))
const customFieldValidation = Yup.string().max(
  255,
  t('validation:maxChars', { max: 255 }),
)

const phoneRegExp = /^\s*[-. (]*(\d{3})[-. )]*(\d{3})[-. ]*(\d{4})\s*$/

const validationSchema = {
  email: Yup.string()
    .email(t('validation:invalidEmail'))
    .required(t('validation:emailRequired')),
  rewardId: Yup.string().required(t('validation:selectReward')),
  termsAccepted: Yup.bool()
    .required(t('validation:requiredField'))
    .oneOf([true], t('validation:requiredField')),
  eighteenOrOver: Yup.bool()
    .required(t('validation:requiredField'))
    .oneOf([true], t('validation:requiredField')), // added to the regular validation schema because its in every RV form
}

const validationSchemaUpload = {
  email: Yup.string()
    .email(t('validation:invalidEmail'))
    .required(t('validation:emailRequired')),
  rewardId: Yup.string().required(t('validation:selectReward')),
}

const nameValidation = {
  firstName: Yup.string()
    .max(80, t('validation:maxChars', { max: 80 }))
    .trim()
    .required(t('validation:firstNameRequired')),

  lastName: Yup.string()
    .max(80, t('validation:maxChars', { max: 80 }))
    .trim()
    .required(t('validation:lastNameRequired')),
}

const addressValidation = {
  address1: Yup.string().required(t('validation:addressRequired')),

  address2: Yup.string(),

  city: Yup.string().required(t('validation:cityRequired')),

  state: Yup.string()
    .required(t('validation:stateRequired'))
    .matches(/^[A-Z]{2}$/, t('validation:selectValidState')),

  postalCode: Yup.string()
    .matches(/^[0-9]+$/, t('validation:onlyDigits'))
    .min(5, t('validation:exactlyFiveDigits'))
    .max(5, t('validation:exactlyFiveDigits'))
    .required(t('validation:postalCodeRequired')),
}

const phoneValidation = {
  phoneNumber: Yup.string()
    .matches(phoneRegExp, t('validation:phoneInvalid'))
    .required(t('validation:phoneRequired')),
}

const confirmationValidation = {
  customConfirmation: Yup.bool()
    .required(t('validation:requiredField'))
    .oneOf([true], t('validation:requiredField')),
}
const customCheckboxesValidation = customCheckboxes => {
  ////keys in object are the name of the field
  let validation = {}
  for (const [key, value] of Object.entries(customCheckboxes)) {
    validation[key] = Yup.bool()
      .required(t('validation:requiredField'))
      .oneOf([true], t('validation:requiredField'))
  }

  return validation
}


// this uses the id of the confirmation box as the name of the 
// input, whereas customCheckboxesValidation uses `key` whichs turns
// into 0, 1, 2
const customCheckboxesValidationReceipt = customCheckboxes => {
  let validation = {}
  customCheckboxes && customCheckboxes.forEach(confirmation => {
    if (confirmation.required) {
      validation[confirmation.id] = Yup.bool()
      .required(t('validation:requiredField'))
      .oneOf([true], t('validation:requiredField'))
    }    
  });

  return validation
}

const createCheckboxValidationSchema = checkboxes => {
  const validation = {}
  checkboxes.forEach(checkbox => {
    const fieldName = checkbox.fieldName || checkbox.id
    if (checkbox.required) {
      validation[fieldName] = Yup.boolean()
        .oneOf([true], t('validation:fieldRequired'))
        .required(t('validation:fieldRequired'))
    } else if (!validation[fieldName]) {
      validation[fieldName] = Yup.boolean()
    }
  })
  return validation
}


const returnDynamicValidation = (
  validationSchema,
  nameRequired,
  addressRequired,
  phoneRequired,
  customCheckboxes
) => {
  let customCheckboxesValidationObj =
    customCheckboxesValidationReceipt(customCheckboxes)
  return {
    ...validationSchema,
    ...(addressRequired && addressValidation),
    ...(phoneRequired && phoneValidation),
    ...(nameRequired && nameValidation),
    ...(customCheckboxes && customCheckboxesValidationObj)
  }
}
const returnDynamicValidationUGC = (
  validationSchema,
  nameRequired,
  addressRequired,
  phoneRequired,
  customConfirmationExists,
  customCheckboxes,
) => {
  let customCheckboxesValidationObj =
    customCheckboxesValidation(customCheckboxes)
  return {
    ...validationSchema,
    ...(addressRequired && addressValidation),
    ...(phoneRequired && phoneValidation),
    ...(customConfirmationExists && confirmationValidation),
    ...(nameRequired && nameValidation),
    ...customCheckboxesValidationObj,
  }
}
export {
  returnDynamicValidation,
  returnDynamicValidationUGC,
  nameValidation,
  phoneRegExp,
  validationSchema,
  validationSchemaUpload,
  addressValidation,
  phoneValidation,
  confirmationValidation,
  zipValidation,
  customFieldValidation,
  createCheckboxValidationSchema,
}
